/**
* @Description: VIP_INTRODUCE
* @author XuZiYu
* @date 2021/12/08 10:02:27
* @update 2022/08/30 ZhanFuzheng 获取车型方式调整
* @update 2022/09/08 ZhanFuzheng 开放视频权益
*/
<template>
    <div class="wrapper-open">

        <!--头部-->
        <template>
            <div class="header">
                <div class="header-left" @click="goBack"><img src="@/assets/vip/icon_back1.png" alt=""/></div>
                <div class="header-main">VIP题库专享特权</div>
                <div class="header-right"></div>
            </div>
        </template>

        <swiper class="swiper" ref="swiper" :options="swiper">
            <swiper-slide><img class="item-img" src="@/assets/vip/picture_jx500.png" alt=""></swiper-slide>
            <swiper-slide><img class="item-img" src="@/assets/vip/picture_kcmn.png" alt=""></swiper-slide>
            <swiper-slide><img class="item-img" src="@/assets/vipV3/picture_spjj.png" alt=""></swiper-slide>
            <swiper-slide><img class="item-img" src="@/assets/vipV3/picture_dtjq.png" alt=""></swiper-slide>
            <swiper-slide><img class="item-img" src="@/assets/vip/picture_znks.png" alt=""></swiper-slide>
            <swiper-slide><img class="item-img" src="@/assets/vip/picture_yctgl.png" alt=""></swiper-slide>
            <swiper-slide><img class="item-img" src="@/assets/vip/picture_kqtj.png" alt=""></swiper-slide>
            <swiper-slide><img class="item-img" src="@/assets/vip/picture_kqmj.png" alt=""></swiper-slide>
            <swiper-slide><img class="item-img" src="@/assets/vip/picture_zsdsj.png" alt=""></swiper-slide>
            <swiper-slide><img class="item-img" src="@/assets/vip/picture_yctgg.png" alt=""></swiper-slide>
            <swiper-slide><img class="item-img" src="@/assets/vipV3/picture_qgg.png" alt=""></swiper-slide>
            <swiper-slide><img class="item-img" src="@/assets/vipV3/picture_lrtt.png" alt=""></swiper-slide>
        </swiper>

        <div class="paging" ref="paging">
            <div class="item" :class="['item', swiperIndex === '0' && 'active']" @click="changeSwiperIndex(0)">
                <img class="item-img" src="@/assets/vip/icon_jx500_01.png" alt="">
                <div class="item-name">精选500题</div>
            </div>
            <div class="item" :class="['item', swiperIndex === '1' && 'active']" @click="changeSwiperIndex(1)">
                <img class="item-img" src="@/assets/vip/icon_kcmn_01.png" alt="">
                <div class="item-name">考场模拟</div>
            </div>
           <div class="item" :class="['item', swiperIndex === '2' && 'active']" @click="changeSwiperIndex(2)">
               <img class="item-img" src="@/assets/vipV3/icon_spjj_01.png" alt="">
               <div class="item-name">视频讲解</div>
           </div>
            <div class="item" :class="['item', swiperIndex === '3' && 'active']" @click="changeSwiperIndex(3)">
                <img class="item-img" src="@/assets/vipV3/icon_dtjq_01.png" alt="">
                <div class="item-name">答题技巧</div>
            </div>
            <div class="item" :class="['item', swiperIndex === '4' && 'active']" @click="changeSwiperIndex(4)">
                <img class="item-img" src="@/assets/vip/icon_znks_01.png" alt="">
                <div class="item-name">智能考试</div>
            </div>
            <div class="item" :class="['item', swiperIndex === '5' && 'active']" @click="changeSwiperIndex(5)">
                <img class="item-img" src="@/assets/vip/icon_yctgl_01.png" alt="">
                <div class="item-name">预测通过率</div>
            </div>
            <div class="item" :class="['item', swiperIndex === '6' && 'active']" @click="changeSwiperIndex(6)">
                <img class="item-img" src="@/assets/vip/icon_kqtj_01.png" alt="">
                <div class="item-name">考前突击</div>
            </div>
            <div class="item" :class="['item', swiperIndex === '7' && 'active']" @click="changeSwiperIndex(7)">
                <img class="item-img" src="@/assets/vip/icon_kqmj_01.png" alt="">
                <div class="item-name">考前秘卷</div>
            </div>
            <div class="item" :class="['item', swiperIndex === '8' && 'active']" @click="changeSwiperIndex(8)">
                <img class="item-img" src="@/assets/vip/icon_zsdsj_01.png" alt="">
                <div class="item-name">知识点速记</div>
            </div>
            <div class="item" :class="['item', swiperIndex === '9' && 'active']" @click="changeSwiperIndex(9)">
                <img class="item-img" src="@/assets/vip/icon_yctgg_01.png" alt="">
                <div class="item-name">易错题巩固</div>
            </div>
            <div class="item" :class="['item', swiperIndex === '10' && 'active']" @click="changeSwiperIndex(10)">
                <img class="item-img" src="@/assets/vipV3/icon_qgg_01.png" alt="">
                <div class="item-name">去广告</div>
            </div>
            <div class="item" :class="['item', swiperIndex === '11' && 'active']" @click="changeSwiperIndex(11)">
                <img class="item-img" src="@/assets/vipV3/icon_lrtt.png" alt="">
                <div class="item-name">懒人听题</div>
            </div>
        </div>

        <div class="footer">
            <div :class="['submit', disabled && 'disabled']" @click="openSubmit()">
                <div class="price">
                    <span class="t1">￥{{ cGoodsDto.payConPrice }}</span><span class="unit">{{ cGoodsDto.effectiveDays | unit }}</span><span class="t2">原价¥{{ cGoodsDto.payOrigPrice }}</span>
                </div>
            </div>
        </div>

        <c-exam-room v-if="examRoomVisible" :cityCode="cityCode" :goodsCode="goodsCode" ref="c-examRoom" @submit="(s)=>{submit(s)}" type="popup"/>

        <van-popup round  v-model="submitVisible" position="bottom" class="submit-popup">
          <div class="popup-title">VIP开通助力驾考 <img src="@/assets/public/icon_gb.png" alt="" @click="submitVisible = false"></div>
          <div class="footer-item-menu" v-if="switchGoods.length > 1">
            <div :class="['footer-item-menu-content',v.goodsCode === cGoodsDto.goodsCode && 'active']" v-for="(v,i) in switchGoods" :key="i" @click="goodsSwitch(v)" >
              <div class="title">{{ v.goodsName }}</div>
              <div class="price">¥<b>{{ v.payConPrice }}</b>{{ v.effectiveDays | unit }}</div>
              <div class="right-top-icon" v-if="v.warnTips">{{ v.warnTips }}</div>
            </div>
          </div>
          <div class="footer-img">
            <img :src="cGoodsDto.introducePicUrl" alt="">
          </div>
          <div class="pay-item" v-if="!IOS" @click="payPopupVisible = true;submitVisible = false">
            <div class="item" v-if="payType === 2">使用 <img src="@/assets/public/icon_wx01.png" alt="">微信，更换支付方式></div>
            <div class="item" v-if="payType === 1">使用 <img src="@/assets/public/icon_zfb01.png" alt="">支付宝，更换支付方式></div>
          </div>
          <div class="pre"></div>
        </van-popup>

        <van-popup :close-on-click-overlay="false" round  v-model="payPopupVisible" position="bottom" class="pay-popup">
          <div class="popup-title">选择支付方式 <img src="@/assets/public/icon_gb.png" alt="" @click="submitVisible=true;payPopupVisible=false"></div>
          <div :class="['wx-item',payType === 2 && 'active']" @click="selectPay(2)">微信支付</div>
          <div class="hr"></div>
          <div :class="['zfb-item',payType === 1 && 'active']"  @click="selectPay(1)">支付宝</div>
        </van-popup>

        <!--消息弹出框-->
        <ctl-dialog v-model="messageDialog" :loading="loading"/>
    </div>
</template>

<script>
import dialog from '@/components/dialog/index.vue'
import { Toast, Button, Popup } from 'vant'
import { Swiper, SwiperSlide } from 'vue-awesome-swiper'
import 'swiper/css/swiper.css'
import cExamRoom from '@/views/vipGoods/components/cExamRoom.vue'

export default {
    name: 'vipIntroduce',
    components: {
        cExamRoom,
        ctlDialog: dialog,
        [Button.name]: Button,
        [Popup.name]: Popup,
        Swiper,
        SwiperSlide
    },
    methods: {
        selectPay (v) {
            this.payType = v
            this.payPopupVisible = false
            this.submitVisible = true
        },
        openSubmit () {
            if (this.submitVisible) {
                this.submit()
            }

            if (this.$refs['c-examRoom'] && this.$refs['c-examRoom'].examRoomVisible) {
                return
            }
            this.submitVisible = true
        },
        // 切换轮播
        changeSwiperIndex (v) {
            this.$refs.swiper.$swiper.slideTo(v, 200)
        },
        // 返回
        goBack () {
            this.$router.back()
        },
        // 转换商品
        goodsSwitch (v) {
            // 防重复点击
            if (this.cGoodsDto.goodsCode === v.goodsCode) {
                return
            }
            Toast.loading({ duration: 0, overlay: true, message: '加载中...' })
            let postData = {
                goodsCode: v.goodsCode
            }
            this.$api.switchGoods(postData).then(res => {
                setTimeout(() => {
                    Toast.clear()
                }, 500)
                if (res.status) {
                    this.goodsCode = v.goodsCode
                    this.cGoodsDto = res.result.settingDto
                    this.pageDto.noneOpendSonSelectedDto = res.result

                    if (this.pageDto.noneOpendSonSelectedDto.containGoodsCode) {
                        this.examRoomVisible = this.pageDto.noneOpendSonSelectedDto.containGoodsCode.includes('105')
                    } else {
                        this.examRoomVisible = false
                    }
                } else {
                    Toast(res.message)
                }
            })
        },
        // 检查车型
        checkCarType () {
            const carTypeName = this.$store.getters.carTypeName

            if (Number(this.carType) !== 1) {
                this.messageDialog = {
                    visible: true,
                    rightBtnName: '切换题库',
                    leftBtnName: '我知道了',
                    leftBtnMethod: () => {
                        this.messageDialog.visible = false
                    },
                    rightBtnMethod: () => {
                        this.messageDialog.visible = false

                        // 进入设置题库页面
                        this.$jsBridge.callBackHandler('pushQuestionBankSettingPage')
                    },
                    title: '温馨提示',
                    content: `该服务现仅适用于小车学员，您当前车型-${carTypeName[this.carType]}，是否需切换回小车题库？`
                }
            }
        },
        // 初始化
        init () {
            // 获取用户数据
            let userInfo = this.$jsBridge.callBackHandler('passUserInfo')

            this.userInfo = userInfo ? JSON.parse(userInfo) : {}

            // app埋点
            this.$jsBridge.callBackHandler('onEventObjectUM', {
                eventId: 'e_ervip_detail_visit',
                map: JSON.stringify({ subject: 3 })
            })

            // 设置车型
            this.carType = this.$jsBridge.callBackHandler('getBankCarType') || (this.$jsBridge.callBackHandler('getCarType') || '1')

            // 设置城市code
            this.cityCode = this.$jsBridge.callBackHandler('passRegionCodeData') || this.$route.query.cityCode

            // 设置版本
            this.version = this.$jsBridge.callBackHandler('getAppVersion') || ''

            // 设置app类型
            this.appType = this.$jsBridge.callBackHandler('getAppType') || (typeof this.$route.query.appType === 'object' ? this.$route.query.appType[0] : this.$route.query.appType)

            // 暴露支付回调方法
            this.$jsBridge.registerHandler('payCallback', this.payCallback)

            // 暴露分享回调方法
            this.$jsBridge.registerHandler('shareCallback', this.shareCallback)

            // 暴露刷新页面方法
            this.$jsBridge.registerHandler('refreshCallBack', this.refreshCallBack)

            if (this.$route.query.type) {
                this.$nextTick(() => {
                    this.changeSwiperIndex(Number(this.$route.query.type) - 1)
                })
            }
        },
        // 获取vip数据
        getData () {
            let postData = {
                cityCode: this.cityCode,
                entryType: '2',
                subject: this.subject,
                goodsCode: this.goodsCode
            }

            postData.examPlaceBatchId = this.$route.query.examPlaceBatchId || ''

            // 判断是否有指定商品
            Toast.loading({ duration: 0, overlay: true, message: '加载中...' })
            this.$api.fixedGoodsEntry(postData).then(res => {
                this.$nextTick(() => {
                    window.scrollTo(0, 0)
                    window.scrollTo(0, 1)
                })
                Toast.clear()

                if (res.status) {
                    if (res.result.generalVipDto || res.result.anyoneVipDto) {
                        this.$router.replace({ name: 'vipGoodsOpened', query: this.$route.query })
                        return
                    }
                    this.pageDto = res.result.noneOpendDto

                    // 默认选择第一个商品
                    this.cGoodsDto = this.pageDto.noneOpendSonSelectedDto.settingDto
                    this.goodsCode = this.pageDto.noneOpendSonSelectedDto.settingDto.goodsCode

                    this.switchGoods = []

                    // 搭配商品选项
                    if (this.pageDto.noneOpendSonHookDtoList) {
                        this.switchGoods = [this.pageDto.noneOpendSonSelectedDto.settingDto, ...this.pageDto.noneOpendSonHookDtoList]
                    }

                    if (res.result.noneOpendDto.noneOpendSonSelectedDto.containGoodsCode) {
                        this.examRoomVisible = res.result.noneOpendDto.noneOpendSonSelectedDto.containGoodsCode.includes('105')
                    } else {
                        this.examRoomVisible = false
                    }

                    this.checkCarType()
                } else {
                    Toast(res.message)
                }
            })
        },
        // 刷新数据
        refreshCallBack () {
            // 重新获取app用户数据
            let userInfo = this.$jsBridge.callBackHandler('passUserInfo')

            this.userInfo = userInfo ? JSON.parse(userInfo) : {}

            // 重新获取app token
            let ctlToken = this.$jsBridge.callBackHandler('passTokenData')

            if (ctlToken) {
                localStorage.setItem('ctl-token', JSON.parse(ctlToken).token)
            }

            // 重新设置车型
            this.carType = this.$jsBridge.callBackHandler('getBankCarType') || (this.$jsBridge.callBackHandler('getCarType') || '1')

            // 重新设置城市code
            this.cityCode = this.$jsBridge.callBackHandler('passRegionCodeData') || this.$route.query.cityCode

            // 刷新数据
            this.getData()
        },
        // 支付回调
        payCallback (v) {
            // 开通成功
            if (String(v) === '1') {
                this.$jsBridge.callBackHandler('openSuccess', { goodsCode: this.goodsCode })
            }
        },
        // 立即开通
        submit (v) {
            if (this.disabled || this.messageDialog.visible) {
                return
            }

            // 除了IOS设备都需要登陆
            if (!this.IOS && !this.userInfo.userId) {
                this.$jsBridge.hasNativeMethod('loginUserV2') ? this.$jsBridge.callBackHandler('loginUserV2') : this.$jsBridge.callBackHandler('loginUser')
                return
            }

            if (!this.submitVisible && !v) {
                this.getData()
                return
            }

            if (this.appType !== 1 && this.version < '3.0.0' && !['100', '101', '105', '104', '107', '200'].includes(this.goodsCode)) {
                Toast('请升级App！')
                return
            }

            // 考场组件选择判断
            if (this.$refs['c-examRoom'] && !v) {
                if (this.$refs['c-examRoom'].examVisible) {
                    this.submitVisible = false
                    this.$refs['c-examRoom'].examRoomVisible = true
                } else {
                    Toast('当前选中的城市没有考场视频！')
                }
                return
            }
            this.examPlaceBatchId = v

            // 请求数据
            let postData = {
                currentUserId: this.userInfo.currentUserId,
                cityCode: this.cityCode,
                examPlaceBatchId: this.examPlaceBatchId,
                goodsCode: this.goodsCode
            }

            this.loading = true
            this.$api.vipGoodsPay(postData).then(res => {
                this.loading = false
                this.submitVisible = false
                // 正常支付流程
                if (res.code === '200' && res.status) {
                    // 判断是否IOS && 苹果支付
                    if (this.IOS) {
                        // 唤起支付
                        this.$jsBridge.callBackHandler('applyPay', {
                            orderId: res.result,
                            productId: this.cGoodsDto.productId,
                            goodsCode: this.goodsCode
                        })
                        return
                    }

                    // 唤起支付
                    this.$jsBridge.callBackHandler('pay', { orderId: res.result, payWay: this.payType, goodsCode: this.goodsCode || '' })
                }

                // 错误状态码处理
                if (res.code === '701') {
                    this.messageDialog = {
                        visible: true,
                        rightBtnName: '去支付',
                        leftBtnName: '取消',
                        leftBtnMethod: () => {
                            this.messageDialog.visible = false
                        },
                        rightBtnMethod: () => {
                            this.messageDialog.visible = false
                            this.goDetail({
                                id: res.result.split('-')[0],
                                orderType: Number(res.result.split('-')[1])
                            })
                        },
                        title: '',
                        content: '您有VIP商品订单未支付'
                    }
                }
                if (!['200', '701'].includes(res.code)) {
                    Toast(res.message)
                }
            })
        },
        // 跳转详情
        goDetail (v) {
            if (v.orderType === 2) {
                this.$router.push({
                    name: 'goodsOrderDetail',
                    query: { id: v.id, goodsCode: this.goodsCode, headShow: '1', sourceType: this.appType === 100 ? '2' : '1' }
                })
            } else if (v.orderType === 4) {
                this.$router.push({
                    name: 'teachVideoOrderDetail',
                    query: { id: v.id, goodsCode: this.goodsCode, headShow: '1' }
                })
            } else if (v.orderType === 6) {
                this.$router.push({
                    name: 'peijiaOrderDetail',
                    query: { id: v.id, goodsCode: this.goodsCode, headShow: '1' }
                })
            } else if (v.orderType === 7) {
                this.$router.push({
                    name: 'ensureOrderDetail',
                    query: { id: v.id, goodsCode: this.goodsCode, headShow: '1' }
                })
            } else if (v.orderType === 8) {
                this.$router.push({
                    name: 'vipPackageOderDetail',
                    query: { id: v.id, goodsCode: this.goodsCode, headShow: '1' }
                })
            } else if (v.orderType === 9) { // 跳转到灯光仿真的订单详情页
                this.$router.push({
                    name: 'goodsLightOrderDetail',
                    query: { id: v.id, goodsCode: this.goodsCode, headShow: '1' }
                })
            } else if (v.orderType === 10) { // 跳转到微课的订单详情页
                this.$router.push({
                    name: 'microCourseOrderDetail',
                    query: { id: v.id, goodsCode: this.goodsCode, headShow: '1' }
                })
            } else if (v.orderType === 11) { // 跳转到模拟机的订单详情页
                this.$router.push({
                    name: 'simulationOrderDetail',
                    query: { id: v.id, goodsCode: this.goodsCode, headShow: '1' }
                })
            } else if (v.orderType === 12) { // 跳转到计时卡的订单详情页
                this.$router.push({
                    name: 'timeAppPayOrderDetail',
                    query: { id: v.id, goodsCode: this.goodsCode, headShow: '1' }
                })
            } else if (v.orderType === 13) { // 跳转到微课订单详情页
                this.$router.push({
                    name: 'welfareOrderDetail',
                    query: { id: v.id, goodsCode: this.goodsCode, headShow: '1' }
                })
            } else if (v.orderType === 14) { // 跳转到vip商品订单详情页
                this.$router.push({
                    name: 'vipGoodsOrderDetail',
                    query: { id: v.id, goodsCode: this.goodsCode, headShow: '1' }
                })
            } else {
                this.$router.push({
                    name: 'vipOrderDetail',
                    query: { id: v.id, goodsCode: this.goodsCode, headShow: '1' }
                })
            }
        }
    },
    mounted () {
        this.init()

        this.getData()

        this.checkCarType()
    },
    created () {
        // 暴露支付回调方法
        this.$jsBridge.registerHandler('payCallback', this.payCallback)

        let userInfo = this.$jsBridge.callBackHandler('passUserInfo')

        this.userInfo = userInfo ? JSON.parse(userInfo) : {}

        this.carType = Number(this.$jsBridge.callBackHandler('getBankCarType') || (this.$jsBridge.callBackHandler('getCarType') || 1))
        this.appType = Number(this.$jsBridge.callBackHandler('getAppType') || (typeof this.$route.query.appType === 'object' ? this.$route.query.appType[0] : this.$route.query.appType))

        this.version = this.$jsBridge.callBackHandler('getAppVersion')

        // 暴露支付回调方法
        this.$jsBridge.registerHandler('payCallback', this.payCallback)

        this.disabled = this.carType !== 1

        this.goodsCode = this.$route.query.id
        this.cityCode = this.$jsBridge.callBackHandler('passRegionCodeData') || this.$route.query.cityCode

        this.$jsBridge.registerHandler('refreshCallBack', this.refreshCallBack)
    },
    data () {
        let _this = this
        return {
            // 轮播数据
            swiper: {
                slidesPerView: 1.25,
                centeredSlides: true,
                on: {
                    slideChangeTransitionEnd: function () {
                        _this.swiperIndex = String(this.activeIndex)
                        let index = Number(this.activeIndex)
                        if (index === 4 || index === 5) {
                            _this.$refs.paging.scrollLeft = 200
                        } else if (index === 3) {
                            _this.$refs.paging.scrollLeft = 0
                        } else if (index === 6) {
                            _this.$refs.paging.scrollLeft = 400
                        } else if (index >= 7 && index <= 11) {
                            _this.$refs.paging.scrollLeft = 600
                        }
                    }
                }
            },
            // 轮播index
            swiperIndex: '0',
            // 支付方式
            payType: 2,
            // 城市code
            cityCode: '',
            // 支付显示
            payPopupVisible: false,
            // 商品id
            goodsCode: '',
            // 用户数据
            userInfo: {},
            // 车型默认小车
            carType: '1',
            // loading
            loading: false,
            // 支付显示
            submitVisible: false,
            // 考场显示
            examRoomVisible: false,
            // 显示分享
            shareVisible: false,
            // app类型 1-定制版 2-学时版
            appType: '',
            // 苹果标记
            IOS: !!(navigator.userAgent).match(/\(i[^;]+;( U;)? CPU.+Mac OS X/),
            // 弹窗数据
            messageDialog: {
                visible: false,
                rightBtnName: '',
                leftBtnName: '',
                leftBtnMethod: '',
                rightBtnMethod: '',
                title: '',
                content: ''
            },
            disabled: false,
            examPlaceBatchId: '',
            version: '',
            cGoodsDto: {},
            switchGoods: []
        }
    }
}
</script>

<style lang="scss" scoped>
.header{
  position: sticky;
  top: 0;
  z-index: 9;
  background: #ffffff;
  display: flex;
  align-items: center;
  padding: 13px 10px;
  .header-left,.header-right{
    display: flex;
    align-items: center;
    width: 100px;
    img{
      width: 24px;
    }
  }
  .header-right{
    justify-content: flex-end;
    img+img{
      margin: 0 0 0 13px;
    }
  }
  .header-main{
    white-space: nowrap;
    text-align: center;
    flex: 1;
    font-size: 18px;
    font-weight: 600;
    color: #333333;
  }
}

.wrapper-open {
    background: #212528;

    .swiper {
        margin-top: 20px;

        .swiper-slide {
            text-align: center;
            transform: translate3d(0, 0, 0);
            box-sizing: content-box;
            padding-bottom: 0.05rem;
            margin-top: -0.05rem;
        }

        .item-img {
            margin: 0 auto;
            width: 250px;
            min-height: 380px;
        }

        .swiper-slide-next, .swiper-slide-prev {
            opacity: 0.5;
        }
    }
    @media screen and (min-height: 780px) {
        .swiper {
            margin-top: 60px;
            .item-img {
                width: 280px;
            }
        }
        .paging {
            bottom: 120px !important;
        }
    }

    .paging {
        position: absolute;
        bottom: 85px;
        box-sizing: border-box;
        width: 100%;
        -webkit-overflow-scrolling: touch;
        overflow: auto;
        touch-action: auto;
        padding-left: 20px;
        white-space: nowrap;
        margin-top: 60px;

        .item {
            margin-right: 15px;
            text-align: center;
            display: inline-block;
        }

        .item-img {
            width: 45px;
            opacity: 0.5;
        }

        .item-name {
            margin-top: 10px;
            font-size: 13px;
            font-weight: 400;
            color: #999999;
        }

        .item.active {
            .item-name {
                color: #FFE2B8;
            }

            .item-img {
                opacity: 1;
            }
        }
    }

    .pay-course {
        font-weight: bold;
        margin: 0 10px 15px 0;
        text-decoration: underline;
        font-size: 13px;
        color: #FFFFFF;
        text-align: right;
        line-height: 1;
    }

    .van-button {
        height: 100%;
        border: none;
    }

    .van-button__loading {
        margin: 0 auto;
        vertical-align: middle;
    }

    .bg {
        line-height: 1;
        font-size: 0;

        img {
            width: 375px;
        }
    }
}
.footer-item-menu{
  margin: 5px 0 0 0;
  display: flex;
  justify-content: center;
  padding: 10px;
  .footer-item-menu-content{
    position: relative;
    box-sizing: border-box;
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    height: 88px;
    background: #FFFFFF;
    border-radius: 5px;
    border: 1px solid #C0C1C4;
    text-align: center;
    line-height: 1;
    .title{
      font-size: 15px;
      line-height: 18px;
      font-weight: 600;
      color: #6A220D;
    }
    .price{
      margin: 5px 0 0 0;
      font-size: 15px;
      color: #6A220D;
    }
    .right-top-icon{
      position: absolute;
      background: #FEE068;
      border-radius: 2px 5px 2px 5px;
      font-size: 12px;
      font-weight: 600;
      color: #7F2500;
      padding: 3px 4px;
      transform-origin: 0 0;
      top: -6px;
      z-index: 99;
      right: -1px;
    }
  }
  .footer-item-menu-content+.footer-item-menu-content{
    margin: 0 0 0 5px;
  }
  .footer-item-menu-content.active{
    background: #212528;
    .title,.price{
      color: #FFFFFF;
    }
    &::after{
      content: ' ';
      position: absolute;
      right: -1px;
      bottom: -1px;
      width: 40px;
      height: 18px;
      background: url("~@/assets/vipGoods/yx2.png") no-repeat 100%/100%;
    }
    .right-top-icon{
      color: #FFFFFF;
      background: #FF5825;
    }
  }
}
.footer{
  position: absolute;
  bottom: 0;
  width: 100%;
  z-index: 99999;
  box-sizing: border-box;
  padding: 5px 10px;
  background: #ffffff;
  .submit{
    position: relative;
    margin: 0 auto;
    height: 60px;
    background: url("~@/assets/vipGoods/ljkt.gif") no-repeat 100%/100%;
    .price{
      margin: 0 0 0 20px;
      position: absolute;
      transform: translateY(-50%);
      top: 50%;
    }
    .price .t1{
      font-size: 24px;
      font-weight: 600;
      color: #FFFFFF;
    }
    .price .unit {
      color: #fff;
      font-size: 15px;
    }
    .price .t2{
      font-size: 15px;
      color: rgba(255, 255, 255, 0.6);
      margin: 0 0 0 5px;
      text-decoration: line-through;
    }
  }
  .submit.disabled{
    background: url("~@/assets/vipGoods/icon_dban_zh.png") no-repeat 100%/100%;
  }
}
.footer-img{
  font-size: 0;
  width: 375px;
  height: 230px;
  overflow: auto;
  img{
    width: 100%;
  }
}
.pay-item{
  padding: 10px 0 5px 0;
  .item{
    justify-content: center;
    display: flex;
    align-items: center;
    font-size: 13px;
    color: #000000;
    img{
      margin: 0 1px;
      width: 16px;
    }
  }
}
.pre{
  height: 68px;
}

.submit-popup{
  border-radius: 10px 10px 0 0;
  .popup-title{
    padding: 20px 10px 0;
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-weight: 600;
    font-size: 18px;
    color: #000000;
    img{
      width: 18px;
    }
  }
}
.pay-popup{
  z-index: 999999 !important;
  border-radius: 10px 10px 0 0;
  padding: 0 0 43px 0;
  .popup-title{
    padding: 20px 10px 0;
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: 600;
    font-size: 18px;
    color: #000000;
    margin: 0 0 43px 0;
    img{
      position: absolute;
      right: 10px;
      width: 18px;
    }
  }
  .wx-item {
    padding: 0 15px;
    font-size: 15px;
    color: #000000;
    display: flex;
    align-items: center;

    &::before {
      margin: 0 10px 0 0;
      display: block;
      content: ' ';
      background: url('~@/assets/public/icon_wx01.png') no-repeat 100%/100%;
      width: 24px;
      height: 24px;
    }
  }
  .hr{
    width: 345px;
    height: 1px;
    background: #EEEEEE;
    margin: 13px auto;
  }
  .zfb-item{
    padding: 0 15px;
    font-size: 15px;
    color: #000000;
    display: flex;
    align-items: center;
    &::before{
      margin: 0 10px 0 0;
      display: block;
      content: ' ';
      background: url('~@/assets/public/icon_zfb01.png') no-repeat 100%/100%;
      width: 24px;
      height: 24px;
    }
  }
  .active::after{
    position: absolute;
    right: 15px;
    display: block;
    content: ' ';
    background: url('~@/assets/public/icon_gxzffs.png') no-repeat 100%/100%;
    width: 18px;
    height: 18px;
  }
}
</style>
